// extracted by mini-css-extract-plugin
module.exports = {"container":"IVZeSQ","label":"_1JANDG","input":"SASsLv"};